export enum RoleCode {
  ORG_LEAD = "ORG_LEAD",
  DEPT_LEAD = "DEPT_LEAD",
  TEAM_LEAD = "TEAM_LEAD",
  COACH = "COACH",
  USER = "USER",
}

export const ROLE_HIERARCHY_LEVEL: Record<RoleCode, number> = {
  [RoleCode.ORG_LEAD]: 1,
  [RoleCode.DEPT_LEAD]: 2,
  [RoleCode.TEAM_LEAD]: 3,
  [RoleCode.COACH]: 4,
  [RoleCode.USER]: 5,
};
